"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Flex_1 = require("./Flex");
const Icon_1 = require("./Icon");
const Link_1 = require("./Link");
const constants_1 = require("../constants");
const StyledLink = (0, styled_1.default)(Link_1.Link)((props) => ({
    color: props.active ? constants_1.Color.BLACK : constants_1.Color.DARK_GREY,
    fontSize: 14,
    fontWeight: constants_1.theme.font.weight.medium,
}));
const BreadcrumbItem = (props) => {
    return ((0, jsx_runtime_1.jsxs)("li", { style: { listStyle: 'none', margin: 0, display: 'flex' }, children: [(0, jsx_runtime_1.jsx)(StyledLink, { active: props.isLast, to: props.to, children: props.label }), !props.isLast && ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { color: constants_1.Color.DARK_MEDIUM_GREY, size: "sm", name: "ChevronRightIcon", mx: 1 }))] }));
};
const Breadcrumbs = (props) => {
    return ((0, jsx_runtime_1.jsx)("nav", { "aria-label": "Breadcrumb", children: (0, jsx_runtime_1.jsx)(Flex_1.Flex, { as: "ol", styles: { m: 0, alignItems: 'center' }, children: props.items.map((item, index) => ((0, jsx_runtime_1.jsx)(BreadcrumbItem, { to: item.to, label: item.label, isLast: index === props.items.length - 1 }, item.to))) }) }));
};
exports.Breadcrumbs = Breadcrumbs;
